export function formatUrl(url: string): string {
  return url.replace(/(https?:)\/{2,}/gi, '$1//');
}

export function removeTrailingSlash(text: string): string {
  return text.replace(/\/$/, '');
}